import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';

export const getJournalTemplates = createAsyncThunk(
  'journalTemplate/getJournalTemplates',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/journal_templates`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getJournalTemplateByID = createAsyncThunk(
  'journalTemplate/getJournalTemplateByID',
  async ({ id }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(
        `/journal_templates/${id}`
      );
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveJournalTemplate = createAsyncThunk(
  'journalTemplate/saveJournalTemplate',
  async ({ entry, name, isCreate, id }, { getState, rejectWithValue }) => {
    try {
      let response;
      const data = {
        entry,
        name,
      };
      if (!isCreate) {
        response = await securedAxiosInstance.put(
          `/journal_templates/${id}`,
          data
        );
      } else {
        response = await securedAxiosInstance.post(`/journal_templates`, data);
      }

      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteJournalTemplate = createAsyncThunk(
  'journalTemplate/deleteJournalTemplate',
  async ({ id }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.delete(
        `/journal_templates/${id}`
      );
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
